"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AvailableFields;
(function (AvailableFields) {
    AvailableFields["invoiceNo"] = "invoiceNo";
    AvailableFields["issueDate"] = "issueDate";
    AvailableFields["dueDate"] = "dueDate";
    AvailableFields["graceDate"] = "graceDate";
    AvailableFields["currencyCode"] = "currencyCode";
    AvailableFields["notes"] = "notes";
    AvailableFields["accountingCost"] = "accountingCost";
    AvailableFields["buyerReference"] = "buyerReference";
    AvailableFields["documentReferences.project.documentNo"] = "documentReferences.project.documentNo";
    AvailableFields["orderReference.documentNo"] = "orderReference.documentNo";
    AvailableFields["billingReferences.invoices"] = "billingReferences.invoices";
    AvailableFields["billingReferences.documentNo"] = "billingReferences.documentNo";
    AvailableFields["billingReferences.issueDate"] = "billingReferences.issueDate";
    AvailableFields["billingReferences.creditNotes"] = "billingReferences.creditNotes";
    AvailableFields["referenceIdentifiers.type"] = "referenceIdentifiers.type";
    AvailableFields["referenceIdentifiers.code"] = "referenceIdentifiers.code";
    AvailableFields["referenceIdentifiers.value"] = "referenceIdentifiers.value";
    AvailableFields["referenceIdentifiers"] = "referenceIdentifiers";
    AvailableFields["supplier.vatNumber"] = "supplier.vatNumber";
    AvailableFields["supplier.address.streetNameAndNumber"] = "supplier.address.streetNameAndNumber";
    AvailableFields["supplier.address.city"] = "supplier.address.city";
    AvailableFields["supplier.address.postalZone"] = "supplier.address.postalZone";
    AvailableFields["supplier.address.countryCode"] = "supplier.address.countryCode";
    AvailableFields["supplier.contact.name"] = "supplier.contact.name";
    AvailableFields["supplier.contact.electronicMail"] = "supplier.contact.electronicMail";
    AvailableFields["supplier.contact.telephone"] = "supplier.contact.telephone";
    AvailableFields["supplier.name"] = "supplier.name";
    AvailableFields["supplier.identifier"] = "supplier.identifier";
    AvailableFields["customer.address.streetNameAndNumber"] = "customer.address.streetNameAndNumber";
    AvailableFields["customer.address.city"] = "customer.address.city";
    AvailableFields["customer.address.postalZone"] = "customer.address.postalZone";
    AvailableFields["customer.address.countryCode"] = "customer.address.countryCode";
    AvailableFields["customer.contact.name"] = "customer.contact.name";
    AvailableFields["customer.contact.electronicMail"] = "customer.contact.electronicMail";
    AvailableFields["customer.contact.telephone"] = "customer.contact.telephone";
    AvailableFields["customer.name"] = "customer.name";
    AvailableFields["customer.identifier"] = "customer.identifier";
    AvailableFields["customer.locationIdentifier"] = "customer.locationIdentifier";
    AvailableFields["payee.name"] = "payee.name";
    AvailableFields["payee.identifier"] = "payee.identifier";
    AvailableFields["payee.sepaBankIdentification"] = "payee.sepaBankIdentification";
    AvailableFields["invoiceLines.itemNo"] = "invoiceLines.itemNo";
    AvailableFields["invoiceLines.name"] = "invoiceLines.name";
    AvailableFields["invoiceLines.quantity"] = "invoiceLines.quantity";
    AvailableFields["invoiceLines.uniteOfMeasure.unit"] = "invoiceLines.unitOfMeasure.unit";
    AvailableFields["invoiceLines.uniteOfMeasure.code"] = "invoiceLines.unitOfMeasure.code";
    AvailableFields["invoiceLines.unitPriceAmount"] = "invoiceLines.unitPriceAmount";
    AvailableFields["invoiceLines.taxCategoryType"] = "invoiceLines.taxCategoryType";
    AvailableFields["invoiceLines.taxableAmount"] = "invoiceLines.taxableAmount";
    AvailableFields["invoiceLines.taxAmount"] = "invoiceLines.taxAmount";
    AvailableFields["invoiceLines.taxPercentage"] = "invoiceLines.taxPercentage";
    AvailableFields["invoiceLines.discountValue"] = "invoiceLines.discountValue";
    AvailableFields["paymentTerms.note"] = "paymentTerms.note";
    AvailableFields["paymentMeans.type"] = "paymentMeans.type";
    AvailableFields["paymentMeans.internationalTransfer"] = "paymentMeans.internationalTransfer";
    AvailableFields["paymentMeans.domesticTransfer"] = "paymentMeans.domesticTransfer";
    AvailableFields["paymentMeans.domesticClaim"] = "paymentMeans.domesticClaim";
    AvailableFields["delivery.partyName"] = "delivery.partyName";
    AvailableFields["delivery.locationIdentifier"] = "delivery.locationIdentifier";
    AvailableFields["delivery.address.streetNameAndNumber"] = "delivery.address.streetNameAndNumber";
    AvailableFields["delivery.address.city"] = "delivery.address.city";
    AvailableFields["delivery.address.postalZone"] = "delivery.address.postalZone";
    AvailableFields["delivery.address.countryCode"] = "delivery.address.countryCode";
    AvailableFields["delivery.actualDeliveryDate"] = "delivery.actualDeliveryDate";
    AvailableFields["prepaidAmount"] = "prepaidAmount";
    AvailableFields["payableAmount"] = "payableAmount";
    AvailableFields["payableRoundingAmount"] = "payableRoundingAmount";
})(AvailableFields = exports.AvailableFields || (exports.AvailableFields = {}));
// export const receiverRequirementsObject: ReceiverRequirements = {
//     invoiceNo: {
//         isRequired: true,
//         key: "",
//     },
//     issueDate: {
//         isRequired: true,
//         key: "",
//     },
//     dueDate: {
//         isRequired: true,
//         key: "",
//     },
//     graceDate: {
//         isRequired: false,
//         key: "",
//     },
//     currencyCode: {
//         isRequired: true,
//         key: "",
//         values: [{
//             key: "ISK",
//             // label: "Icelandic krona (ISK)"
//             label: "Íslensk króna (ISK)"
//         }]
//     },
//     notes: {
//         isRequired: false,
//         key: "",
//     },
//     accountingCost: {
//         isRequired: false,
//         key: "",
//     },
//     buyerReference: {
//         isRequired: true,
//         key: "",
//         label: "Tjónsnúmer / Tilvísun kaupanda" // Claim number / Buyer reference
//     },
//     "orderReference.documentNo": {
//         isRequired: true,
//         key: "",
//     },
//     "billingReferences.invoices": {
//         isRequired: false,
//         key: "",
//     },
//     "billingReferences.documentNo": {
//         isRequired: true,
//         key: "",
//     },
//     "billingReferences.issueDate": {
//         isRequired: false,
//         key: "",
//     },
//     "billingReferences.creditNotes": {
//         isRequired: false,
//         key: "",
//     },
//     // "referenceIdentifiers.type": {
//     //     isRequired: false,
//     //     key: "",
//     //     label: "Reference identifier type"
//     // },
//     // "referenceIdentifiers.code": {
//     //     isRequired: false,
//     //     key: "",
//     //     label: "Reference identifier code"
//     // },
//     // "referenceIdentifiers.value": {
//     //     isRequired: true,
//     //     key: "",
//     //     label: "Reference identifier value"
//     // },
//     "referenceIdentifiers": {
//         "isRequired": true,
//         "key": "",
//         "values": [
//             {
//                 "key": "AKY",
//                 "label": "Bílnúmer",
//                 "values": [
//                     {
//                         "key": "NY753",
//                         "label": "NY753"
//                     }, // displaed as "NY753"
//                     {
//                         "key": "IS123"
//                     }, // display key
//                     {
//                         "key": "RR888"
//                     }, // display key
//                 ]
//             },
//             {
//                 "key": "ARR", // WAS SSN!!!!
//                 "label": "Kennitala" // "Social security number"
//             },
//             {
//                 "key": "LOC",
//                 "label": "Fasteignanúmer", // Place or location identifier
//                 "values": [{
//                     "key": "30909",
//                     "label": "Mýrargata 26 (30909)"
//                 }, // displayed as "Mýrargata 26 (30909)"
//                     {
//                         "key": "34344",
//                         "label": "Aragata 1 (34344)"
//                     }, // displayed as "Aragata (34344)"
//                 ]
//             }
//         ]
//     },
//
//     "supplier.vatNumber": {
//         isRequired: false, // NBNB: this is by request from Sjova, but as the VAT number is required in model validation, we are inserting N/A if this field is empty
//         key: "",
//     },
//     "supplier.address.streetNameAndNumber": {
//         isRequired: true,
//         key: "",
//     },
//     "supplier.address.city": {
//         isRequired: false,
//         key: "",
//     },
//     "supplier.address.postalZone": {
//         isRequired: false,
//         key: "",
//     },
//     "supplier.address.countryCode": {
//         isRequired: true,
//         key: "",
//     },
//     "supplier.contact.name": {
//         isRequired: false,
//         key: "",
//     },
//     "supplier.contact.electronicMail": {
//         isRequired: false,
//         key: "",
//     },
//     "supplier.contact.telephone": {
//         isRequired: false,
//         key: "",
//     },
//     "supplier.name": {
//         isRequired: true,
//         key: "",
//     },
//     "supplier.identifier": {
//         isRequired: true,
//         key: "",
//     },
//
//     "customer.address.streetNameAndNumber": {
//         isRequired: true,
//         key: "",
//     },
//     "customer.address.city": {
//         isRequired: false,
//         key: "",
//     },
//     "customer.address.postalZone": {
//         isRequired: false,
//         key: "",
//     },
//     "customer.address.countryCode": {
//         isRequired: true,
//         key: "",
//     },
//     "customer.contact.name": {
//         isRequired: false,
//         key: "",
//     },
//     "customer.contact.electronicMail": {
//         isRequired: false,
//         key: "",
//     },
//     "customer.contact.telephone": {
//         isRequired: false,
//         key: "",
//     },
//     "customer.name": {
//         isRequired: true,
//         key: "",
//     },
//     "customer.identifier": {
//         isRequired: true,
//         key: "",
//     },
//     "customer.locationIdentifier": {
//         isRequired: false,
//         key: "",
//     },
//
//     "payee.name": {
//         isRequired: true,
//         key: "",
//     },
//     "payee.identifier": {
//         isRequired: true,
//         key: "",
//     },
//     "payee.sepaBankIdentification": {
//         isRequired: false,
//         key: "",
//     },
//
//     "invoiceLines.itemNo": {
//         isRequired: true,
//         key: "",
//     },
//     "invoiceLines.name": {
//         isRequired: true,
//         key: "",
//     },
//     "invoiceLines.quantity": {
//         isRequired: true,
//         key: "",
//     },
//     "invoiceLines.unitOfMeasure.unit": {
//         isRequired: true,
//         key: "",
//     },
//     "invoiceLines.unitOfMeasure.code": {
//         isRequired: true,
//         key: "",
//     },
//     "invoiceLines.unitPriceAmount": {
//         isRequired: true,
//         key: "",
//     },
//     "invoiceLines.taxCategoryType": {
//         isRequired: true,
//         key: "",
//     },
//     "invoiceLines.taxAmount": {
//         isRequired: true,
//         key: "",
//     },
//     "invoiceLines.taxableAmount": {
//         isRequired: true,
//         key: "",
//     },
//     "invoiceLines.taxPercentage": {
//         isRequired: true,
//         key: "",
//     },
//     "invoiceLines.discountValue": {
//         isRequired: true,
//         key: "",
//     },
//
//     "paymentTerms.note": {
//         isRequired: false,
//         key: "",
//     },
//     "paymentMeans.type": {
//         isRequired: true,
//         key: "",
//     },
//
//     "paymentMeans.internationalTransfer": {
//         isRequired: false,
//         key: "",
//     },
//     "paymentMeans.domesticTransfer": {
//         isRequired: false,
//         key: "",
//     },
//     "paymentMeans.domesticClaim": {
//         isRequired: false,
//         key: "",
//     },
//
//     "delivery.partyName": {
//         isRequired: false,
//         key: "",
//     },
//     "delivery.locationIdentifier": {
//         isRequired: false,
//         key: "",
//     },
//     "delivery.address.streetNameAndNumber": {
//         isRequired: false, // ??
//         key: "",
//     },
//     "delivery.address.city": {
//         isRequired: false,
//         key: "",
//     },
//     "delivery.address.postalZone": {
//         isRequired: false,
//         key: "",
//     },
//     "delivery.address.countryCode": {
//         isRequired: false, // ??
//         key: "",
//     },
//     "delivery.actualDeliveryDate": {
//         isRequired: false,
//         key: "",
//     },
//
//     prepaidAmount: {
//         isRequired: false,
//         key: "",
//     },
//     payableAmount: {
//         isRequired: false,
//         key: "",
//     },
//     payableRoundingAmount: {
//         isRequired: false,
//         key: "",
//     }
// };
